// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var ScheduledEventType;
(function (ScheduledEventType) {
    ScheduledEventType["CREATE_REPORT"] = "CREATE_REPORT";
    ScheduledEventType["UPDATE_VOTING_STATUS"] = "UPDATE_VOTING_STATUS";
    ScheduledEventType["CREATE_BOARD"] = "CREATE_BOARD";
    ScheduledEventType["CREATE_KEYS"] = "CREATE_KEYS";
    ScheduledEventType["SET_PUBLIC_KEY"] = "SET_PUBLIC_KEY";
    ScheduledEventType["CREATE_ELECTION_EVENT_BALLOT_STYLES"] = "CREATE_ELECTION_EVENT_BALLOT_STYLES";
    ScheduledEventType["TALLY_ELECTION_EVENT"] = "TALLY_ELECTION_EVENT";
    ScheduledEventType["SEND_TEMPLATE"] = "SEND_TEMPLATE";
})(ScheduledEventType || (ScheduledEventType = {}));
/**
 * The list filter of scheduled events that are still events: not archived.
 * A bulk notification (Send Notification) is stored as a stopped, archived
 * `SEND_TEMPLATE` row, kept only as the content its retries are sent from,
 * so it is never listed, edited or rescheduled here.
 */
export var ACTIVE_SCHEDULED_EVENTS = {
    archived_at: { format: "hasura-raw-query", value: { _is_null: true } },
};
